import React from 'react';
import { Router, Route, Switch } from 'react-router-dom';

import Dashboard from '../Dashboard';
import Callback from '../Callback';

const Routes = ({ history }) => {
  return (
    <Router history={history}>
      <Switch>
        <Route path="/dashboard" component={Dashboard} />
        <Route exact path="/callback" component={Callback} />
      </Switch>
    </Router>
  );
};

export default Routes;



// WEBPACK FOOTER //
// ./src/app/containers/App/Routes.jsx